var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.scale!=null)?_c('div',{staticClass:"scale-displayer"},_vm._l((_vm.scale),function(tone,i){return _c('div',{key:i,staticClass:"tone-container"},[_c('div',{staticClass:"tone",style:({ 'background-color' : tone =='null'?'#ffffff':tone })})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }